import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { NotYourFault } from './components/NotYourFault';
import { ProductIntro } from './components/ProductIntro';
import { Benefits } from './components/Benefits';
import { Curriculum } from './components/Curriculum';
import { Bonuses } from './components/Bonuses';
import { Audience } from './components/Audience';
import { BeforeAfter } from './components/BeforeAfter';
import { OfferStack } from './components/OfferStack';
import { AboutAuthor } from './components/AboutAuthor';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-full bg-ink-950 font-sans text-white" data-id="element-0" data-mp="28tme50nv46w6">
      <main data-id="element-1" data-mp="23vkwmk634fmt">
        <Hero data-id="element-2" data-mp="23vuq4hqc94x9" />
        <ProblemSection data-id="element-3" data-mp="23u9u0nodldxa" />
        <NotYourFault data-id="element-4" data-mp="23ut9lxqjzq85" />
        <ProductIntro data-id="element-5" data-mp="23ti7e2craqj5" />
        <Benefits data-id="element-6" data-mp="3ik7jmqgv0tve" />
        <Curriculum data-id="element-7" data-mp="3iiwdijzxza14" />
        <Bonuses data-id="element-8" data-mp="3ijfw82xf22g7" />
        <Audience data-id="element-9" data-mp="3ihv2ugmu8pjx" />
        <BeforeAfter data-id="element-10" data-mp="3mlj8gtrwtb2j" />
        <OfferStack data-id="element-11" data-mp="3ml17xky7saot" />
        <AboutAuthor data-id="element-12" data-mp="3mk8710lxsfel" />
        <Guarantee data-id="element-13" data-mp="3mjq3diwy2ywn" />
        <FAQ data-id="element-14" data-mp="3mj6jhwnqi0fz" />
        <FinalCTA data-id="element-15" data-mp="3rcj6k2crlz6m" />
      </main>
      <Footer data-id="element-16" data-mp="3rdar8i4tqci4" />
    </div>;
}